import React from 'react';

const Hero = ({ openbar }) => {
	return (
		<div>
			<section className='flex justify-center items-center min-h-screen px-12'>
				<h1
					style={{ display: openbar ? 'none' : 'block' }}
					className='text-2xl text-blue-100 font-bold font-cursive leading-none lg:first-letter:leading-snug text-center md:text-4xl lg:pt-4 lg:text-5xl'
				>
					Hi! I'm Fırat
					<br />A Front-end Developer
				</h1>
			</section>
		</div>
	);
};

export default Hero;
